var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 5L19 12.5L21 8L29 5Z",
    fill: "#E2761B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94629 5L15.8705 12.501L14.1109 8.04665L5.94629 5Z",
    fill: "#E4761B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 22L22.7789 26.3058L28.4801 27.8744L30.0001 22H25.0001Z",
    fill: "#E4761B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22L6.6289 27.6509L12.33 26.0823L10 22H5Z",
    fill: "#E4761B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 15.3263L10.3109 17.7294L15.9718 17.9808L15.7707 11.8976L11.8996 15.3263Z",
    fill: "#E4761B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0908 15.326L19.1694 11.8269L19.0387 17.9805L24.6896 17.7292L23.0908 15.326Z",
    fill: "#E4761B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 26.5L15.62 24.6477L12.684 22.3552L11.9998 26.5Z",
    fill: "#E4761B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3699 24.6477L22.9998 26.5L22.3059 22.3552L19.3699 24.6477Z",
    fill: "#E4761B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26.5L19.3711 24.6467L19.6426 27.0068L19.6124 28L23 26.5Z",
    fill: "#D7C1B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 26.5L15.389 28L15.3689 27.0068L15.6202 24.6467L12 26.5Z",
    fill: "#D7C1B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21L13 20.046L14.4113 19L15 21Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21L20.5866 19L22 20.046L20 21Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2217 26.307L13 22H9L12.2217 26.307Z",
    fill: "#CD6116"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 22L22.7796 26.307L26.0001 22H22.0001Z",
    fill: "#CD6116"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6898 17.7295L19.0389 17.9809L19.5618 20.8867L20.3964 19.1372L22.4073 20.0522L24.6898 17.7295Z",
    fill: "#CD6116"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6036 20.0522L14.6145 19.1372L15.4391 20.8867L15.972 17.9809L10.311 17.7295L12.6036 20.0522Z",
    fill: "#CD6116"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.311 17.7295L12.684 22.3548L12.6036 20.0522L10.311 17.7295Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4073 20.0522L22.3068 22.3548L24.6898 17.7295L22.4073 20.0522Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9724 17.9807L15.4395 20.8866L16.1031 24.3153L16.2539 19.8007L15.9724 17.9807Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0391 17.9807L18.7676 19.7906L18.8882 24.3153L19.5619 20.8866L19.0391 17.9807Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5743 20.9081L19 24.639L19.4114 25L21.9143 22.5055L22 20L19.5743 20.9081Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20L13.069 22.5055L15.5862 25L16 24.639L15.431 20.9081L13 20Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 27.8245L19.7314 26.6857L19.4695 26.4163H15.52L15.279 26.6857L15.3 27.8245L12 26L13.1524 27.102L15.4886 29H19.501L21.8476 27.102L23 26L19.7 27.8245Z",
    fill: "#C0AD9E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6824 24.3898L19.1176 24H15.8588L15.2941 24.3898L15 27L15.2706 26.7402H19.7059L20 27L19.6824 24.3898Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.466 12.9132L30.3207 8.81082L29.0437 5L19.3708 12.1792L23.0912 15.3264L28.3499 16.8648L29.5163 15.5074L29.0135 15.1454L29.8179 14.4114L29.1945 13.9288L29.9989 13.3154L29.466 12.9132Z",
    fill: "#763D16"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68018 8.81082L5.53485 12.9132L4.99188 13.3154L5.79627 13.9288L5.18292 14.4114L5.98732 15.1454L5.48457 15.5074L6.64089 16.8648L11.8996 15.3264L15.6199 12.1792L5.9471 5L4.68018 8.81082Z",
    fill: "#763D16"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1879 16.5322L22.8031 15L24.4402 17.3934L22 22H25H30L28.1879 16.5322Z",
    fill: "#F6851B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1948 15L6.79613 16.5322L5 22H10H13L10.5639 17.3934L12.1948 15Z",
    fill: "#F6851B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0815 17.7701L19.4237 12.0643L21 8H14L15.5556 12.0643L15.9185 17.7701L16.043 19.5698L16.0533 24H18.9259L18.9467 19.5698L19.0815 17.7701Z",
    fill: "#F6851B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.1f9218bf.svg";
export { ForwardRef as ReactComponent };